import React from 'react';
import { IconProps } from './types';

const CsaCoordinationIcon: React.FC<IconProps> = props => {
  const { fillColor = 'var(--navigation-blue-c2)', width = 24, height = 24 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.68391 18.5064L1.68404 18.5059C2.36375 15.4836 5.07206 13.2262 8.287 13.2262C11.5016 13.2262 14.2097 15.4831 14.8897 18.5049C14.9884 18.9508 14.6642 19.3329 14.2604 19.3329H2.31362C1.91188 19.3329 1.586 18.9401 1.68391 18.5064Z"
        stroke={fillColor}
        strokeWidth="1.33334"
      />
      <path
        d="M11.3672 7.73336C11.3672 9.42704 9.99418 10.8 8.3005 10.8C6.60681 10.8 5.23381 9.42704 5.23381 7.73336C5.23381 6.03967 6.60681 4.66667 8.3005 4.66667C9.99418 4.66667 11.3672 6.03967 11.3672 7.73336Z"
        stroke={fillColor}
        strokeWidth="1.33334"
      />
      <path
        d="M14.4871 11.9459C15.1137 11.7059 15.8071 11.5859 16.5137 11.5859C19.3004 11.5859 21.6204 13.5326 22.2071 16.1326C22.3538 16.786 21.8738 17.426 21.2071 17.426H18.6471"
        stroke={fillColor}
        strokeWidth="1.33334"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5135 9.1193C17.7654 9.1193 18.7802 8.10447 18.7802 6.85262C18.7802 5.60077 17.7654 4.58594 16.5135 4.58594C15.2617 4.58594 14.2468 5.60077 14.2468 6.85262C14.2468 8.10447 15.2617 9.1193 16.5135 9.1193Z"
        stroke={fillColor}
        strokeWidth="1.33334"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CsaCoordinationIcon;
